import React, { ReactNode }           from 'react';
import { createStyles, Stack, Title } from '@mantine/core';


const useStyles = createStyles((
    theme: {
        colors: { [x: string]: any[] };
        colorScheme: string;
        fn: any;
        fontSizes: any;
        spacing: any;
    }) => ({


    h1: {
        fontSize: 28,
        letterSpacing: 0.6,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.dark[4],

        [theme.fn.smallerThan('sm')]: {
            fontSize: 20,
        },

    },


}));

interface Props {
    heading: string;
    content: ReactNode;
    className?: string;
}

/**
 *
 * Use only when you have to render into a page section
 * with headings
 *
 * */
export const CSection: React.FC<Props> = ({
                                                  heading,
                                                  content,
                                                  className
                                              }) => {

    const { classes } = useStyles();

    return (
        <Stack mt={30} mb={30}>

            <Title mb={30} className={classes.h1} order={1}>{heading}</Title>

            <div className={className}>
                {content}
            </div>

        </Stack>
    );

};
